import { render, staticRenderFns } from "./Gradient.vue?vue&type=template&id=a74bc074&"
import script from "./Gradient.vue?vue&type=script&lang=js&"
export * from "./Gradient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports